// confirm 한 attack ops 의 rally 수: **공격 열람 화면 밖으로 내보내는 자리 하나**
//
// ── 왜 이것이 필요했는가 (T2 개정 둘째, 2026-10-01) ──────────────────────────
//
// 연맹원이 열람 화면을 처음 열 때 어느 탭이 먼저 서는지는 CT 가 지금 연 탭이 정한다
// (2026-08-15 사용자 결정). 그래서 CT 가 attack ops 를 confirm 한 뒤 수비를 짜러 DEFENSE
// 탭으로 옮기면, 그때 들어온 연맹원은 빈 수비 화면에 서고 자기 rally 가 곧 열린다는 단서를
// 화면 어디에서도 못 본다. 2026-10-01 대리 관측 둘이 그 상태를 같은 자리에서 잡았다.
// 사용자는 규칙을 그대로 두고 화면이 그 상태를 말하게 하는 쪽을 골랐다.
//
// 「attack ops 가 있는가」는 공격 열람 화면이 들고 있는 값이다. 선택 상태를 위로 올리지 않은
// 것과 같은 이유로(`live-target.ts` 머리 주석) 이 한 값만 내보낸다. 값이 숫자라
// `useSyncExternalStore` 의 참조 비교에 걸릴 것이 없다.

let current = 0
const listeners = new Set<() => void>()

/**
 * 지금 연맹원 화면에 그려진 attack rally 수를 알린다. confirm 전이면 0 이다.
 *
 * 부르는 자리는 공격 열람 화면 하나다. 그 화면은 탭을 옮겨도 감춰진 채 마운트돼 있으므로,
 * defense 탭에 서 있는 동안에도 이 값은 살아 있다.
 */
export function publishAttackRallies(count: number): void {
  if (current === count) return
  current = count
  for (const listener of [...listeners]) listener()
}

export function readAttackRallies(): number {
  return current
}

export function subscribeAttackRallies(listener: () => void): () => void {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}
